import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '../../../lib/utils';

const colorVariants = cva('text-muted-foreground', {
  variants: {
    variant: {
      foreground: 'text-foreground',
      muted: 'text-muted-foreground',
      primary: 'text-primary',
      secondary: 'text-secondary',
      accent: 'text-accent',
      destructive: 'text-destructive',
    },
  },
  defaultVariants: {
    variant: 'muted',
  },
});

export interface FileIconProps
  extends React.SVGProps<SVGSVGElement>, VariantProps<typeof colorVariants> {
  size?: number | string;
}

export const FileIcon = React.forwardRef<SVGSVGElement, FileIconProps>(
  function FileIcon(
    { className, style, size, width, height, variant, ...rest },
    ref,
  ) {
    const w = width ?? size ?? 18;
    const h = height ?? size ?? 22;
    const colorClass = colorVariants({ variant });
    return (
      <svg
        ref={ref}
        width={w}
        height={h}
        viewBox="0 0 18 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn('stroke-current', colorClass, className)}
        style={{ ...(style as React.CSSProperties) }}
        {...rest}
      >
        <path
          d="M11 10H5M7 14H5M13 6H5M17 5.8V16.2C17 17.8802 17 18.7202 16.673 19.362C16.3854 19.9265 15.9265 20.3854 15.362 20.673C14.7202 21 13.8802 21 12.2 21H5.8C4.11984 21 3.27976 21 2.63803 20.673C2.07354 20.3854 1.6146 19.9265 1.32698 19.362C1 18.7202 1 17.8802 1 16.2V5.8C1 4.11984 1 3.27976 1.32698 2.63803C1.6146 2.07354 2.07354 1.6146 2.63803 1.32698C3.27976 1 4.11984 1 5.8 1H12.2C13.8802 1 14.7202 1 15.362 1.32698C15.9265 1.6146 16.3854 2.07354 16.673 2.63803C17 3.27976 17 4.11984 17 5.8Z"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);

FileIcon.displayName = 'FileIcon';
